<div class="d-flex flex-column">
  <div class="mx-auto">
    @if(venmoCodeExists && venmoCodeUrl){
         <a  [href]="venmoProfileUrl" target="_blank" rel="noopener">
            <img
                id="VENMO_CODE_IMG_PAYMENT"
                class="img-fluid"
                [src]="venmoCodeUrl"
                width="220"
                height="220"
                alt="Venmo Code"
            />
        </a>
    }
  </div>
  <p class="mb-0 text-center">
    <strong>Scan</strong> or <strong>Click</strong> on our Venmo code to make your payment through Venmo.
  </p>
</div>
